import React, { createContext, useContext, useState } from "react";
import { useKeycloak } from "@react-keycloak/web";
import useFBOApi from "./api/useFBOApi";
import { NOTIFICATION_PERMISSIONS } from "../utils/constants";

const LogoutContext = createContext({
  isSessionExpired: false,
  isUnauthorized: false,
  handleLogout: () => {},
  handleSessionExpired: () => {},
  handleSessionExpiredConfirm: () => {},
  handleUnauthorized: () => {},
  handleUnauthorizedConfirm: () => {},
  logout: () => {},
});

export const useLogout = () => useContext(LogoutContext);

export const LogoutProvider = ({ children }) => {
  const { keycloak } = useKeycloak();
  const [isSessionExpired, setIsSessionExpired] = useState(false);
  const [isUnauthorized, setIsUnauthorized] = useState(false);
  const { removeDeviceToken } = useFBOApi();

  const logout = () => {
    sessionStorage.clear();
    keycloak.logout();
  };

  const handleLogout = async () => {
    try {
      const permission = await Notification.requestPermission();
      if (permission === NOTIFICATION_PERMISSIONS.GRANTED) {
        await removeDeviceToken();
      }
    } catch (error) {
      console.error("Error removing device token:", error);
    }
    setIsSessionExpired(false);
    logout();
  };

  const handleUnauthorized = () => {
    setIsUnauthorized(true);
  };

  const handleSessionExpired = () => {
    setIsSessionExpired(true);
  };

  const handleSessionExpiredConfirm = () => {
    setIsSessionExpired(false);
    keycloak.login();
  };

  const handleUnauthorizedConfirm = () => {
    setIsUnauthorized(false);
    sessionStorage.clear();
    keycloak.logout();
  };

  return (
    <LogoutContext.Provider
      value={{
        isSessionExpired,
        isUnauthorized,
        handleLogout,
        handleSessionExpired,
        handleSessionExpiredConfirm,
        handleUnauthorized,
        handleUnauthorizedConfirm,
        logout,
      }}
    >
      {children}
    </LogoutContext.Provider>
  );
};
